import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { selectIsMobile } from 'redux/modules/device';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { CmsHeading } from 'components/CmsPage/modules/CmsHeading/CmsHeading';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';
import { BackgroundImage } from 'components/Image/BackgroundImage';
import { Section } from 'components/Section/Section';

const FRAMES = ['none', 'regular', 'large', 'huge', 'giga'];
const HEIGHTS = ['auto', 'full-screen', '100-percent'];
const HORIZONTAL_POSITIONS = ['left', 'center', 'right'];
const THEMES = ['white', 'light', 'brand', 'dark', 'black'];
const VERTICAL_POSITIONS = ['top', 'middle', 'bottom'];
const WIDTHS = ['auto', 'phone', 'tablet', 'desktop'];

export const CmsSectionUnwrapped = ({
  backgroundImage,
  cmsModuleId,
  copy,
  height,
  horizontalFrame,
  horizontalPosition,
  modules,
  shouldRemoveInsidePadding,
  theme,
  title,
  verticalFrame,
  verticalPosition,
  width,
}) => {
  const sectionClasses = classNames({
    CmsSection: true,
    [`CmsSection--height-${height}`]: HEIGHTS.includes(height),
    [`CmsSection--horizontal-frame-${horizontalFrame}`]: FRAMES.includes(horizontalFrame),
    [`CmsSection--horizontal-position-${horizontalPosition}`]: HORIZONTAL_POSITIONS.includes(horizontalPosition),
    [`CmsSection--no-padding`]: shouldRemoveInsidePadding,
    [`CmsSection--theme-${theme}`]: THEMES.includes(theme),
    [`CmsSection--vertical-frame-${verticalFrame}`]: FRAMES.includes(verticalFrame),
    [`CmsSection--vertical-position-${verticalPosition}`]: VERTICAL_POSITIONS.includes(verticalPosition),
    [`CmsSection--width-${width}`]: WIDTHS.includes(width),
    [`CmsSection--with-background`]: !!backgroundImage,
  });

  return (
    <BackgroundImage url={backgroundImage}>
      <Section className={sectionClasses}>
        <div className="CmsSection__content">
          <CmsHeading title={title} />
          <CmsText content={copy} cmsModuleId={`Section:Copy:${cmsModuleId}`} />
          <CmsModules modules={modules} />
        </div>
      </Section>
    </BackgroundImage>
  );
};

CmsSectionUnwrapped.propTypes = {
  backgroundImage: PropTypes.string,
  cmsModuleId: PropTypes.string.isRequired,
  copy: PropTypes.string,
  height: PropTypes.string,
  horizontalFrame: PropTypes.string,
  horizontalPosition: PropTypes.string,
  modules: PropTypes.arrayOf(CmsModuleShape),
  shouldRemoveInsidePadding: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
  verticalFrame: PropTypes.string,
  verticalPosition: PropTypes.string,
  width: PropTypes.string,
};

export const mapStateToProps = (state, props) => ({
  backgroundImage: selectIsMobile(state) ? props.imageMobile : props.imageDesktop,
});

export const CmsSection = connect(mapStateToProps)(CmsSectionUnwrapped);
